export const getDateISO = (date: Date): string => {
    return date.toISOString().slice(0, 10);
};

export const getDateRange = (date: Date): string => {
    const stringDate = getDateISO(date);
    return `${stringDate}T00:00:00,${stringDate}T23:59:59`;
};
